import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";
import axios from "../axios/axios";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import FormExperience from "../components/form-experience";
import { Link, useNavigate, useParams } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";

export default function ModifierExperience() {
  const navigate = useNavigate();
  const { idExperience } = useParams();

  const token = Cookies.get("auth_token");
  const [allExperpiances, setAllExperpiances] = useState([]);
  const [searchInputEntreprise, setSearchInputEntreprise] = useState("");
  const [filteredResultsEntreprise, setFilteredResultsEntreprise] = useState(
    []
  );
  const [chargement, setChargement] = useState(false);

  useEffect(() => {
    getExperience();
    getEntreprises();
  }, []);

  const getEntreprises = () => {
    axios
      .get("getDomainesEtEtablissementsEtEntreprises/", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAllExperpiances(response.data.allExperpiance);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [experiences, setExperiences] = useState([
    {
      moisDebutExper: "",
      anneeDebutexper: "",
      moisFinExper: "",
      anneeFinexper: "",
      encoureEper: "",
      titreProjet: "",
      nomEntreprise: "",
      descriptionExperience: "",
    },
  ]);

  const handleChangeExperience = (index, attributeName, value) => {
    // Mettez à jour la liste des formations en modifiant l'attribut spécifique de la formation à l'index donné
    const updatedExperiences = [...experiences];
    updatedExperiences[index][attributeName] = value;
    setExperiences(updatedExperiences);
  };

  const handleCheckboxChangeExperience = (index) => {
    const updatedExperiences = [...experiences];
    updatedExperiences[index].encoureEper =
      !updatedExperiences[index].encoureEper;
    updatedExperiences[index].moisFinExper = "";
    updatedExperiences[index].anneeFinexper = "";
    setExperiences(updatedExperiences);
  };

  const onChangeEntreprise = (e, index) => {
    const updatedExperiences = [...experiences];
    updatedExperiences[index].nomEntreprise = e.target.value;
    setExperiences(updatedExperiences);
    setSearchInputEntreprise(e.target.value);
    if (searchInputEntreprise !== "") {
      const filteredDataEntreprise = allExperpiances.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchInputEntreprise.toLowerCase());
      });
      setFilteredResultsEntreprise(filteredDataEntreprise);
    } else {
      setFilteredResultsEntreprise([]);
    }
  };

  const selectItemsEntreprise = (e, index) => {
    const updatedExperiences = [...experiences];
    updatedExperiences[index].nomEntreprise = e.target.value;
    setExperiences(updatedExperiences);
    setFilteredResultsEntreprise([]);
  };

  const getExperience = () => {
    setChargement(true);

    var moisFinExper = 0;
    var anneeFinexper = 0;
    var encoureEper = null;

    axios
      .get(`/editeExperience/${idExperience}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (
          response.data.msg == "msgNoAuthNoAdmin" ||
          response.data.experience == null
        ) {
          navigate(`${process.env.PUBLIC_URL}/profile`);
        } else {
          const experiences = [response.data.experience];

          const updatedExperiences = experiences.map((experience) => {
            const moisDebutExper = experience.date_debut.substring(5, 7);
            const anneeDebutexper = experience.date_debut.substring(0, 4);
            const nomEntreprise = experience.nom_entreprise;
            const titreProjet = experience.titre_projet;
            const descriptionExperience = experience.description;
            if (experience.date_fin != null && experience.encour == 0) {
              moisFinExper = experience.date_fin.substring(5, 7);
              anneeFinexper = experience.date_fin.substring(0, 4);
            } else {
              encoureEper = experience.encour;
              moisFinExper = "";
              anneeFinexper = "";
            }

            return {
              ...experience,
              moisDebutExper,
              anneeDebutexper,
              moisFinExper,
              anneeFinexper,
              encoureEper,
              nomEntreprise,
              titreProjet,
              descriptionExperience,
            };
          });

          setExperiences(updatedExperiences);
          setChargement(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleModifiereExperience = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Traitement en cours, veuillez patienter ...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const form = new FormData();
    form.append("experiences", JSON.stringify(experiences));

    axios
      .post("/modifierExperience", form, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        Swal.fire({
          icon: "success",
          text: "Votre Experience a été modifier avec succès!",
          confirmButtonText: "Ok",
        }).then(function () {
          if (response.data.user.role == 1) {
            navigate(`${process.env.PUBLIC_URL}/rim`);
          } else {
            navigate(`${process.env.PUBLIC_URL}/consulter-voter-cv`);
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return chargement == true ? (
    <div className="container card text-center mt-5">
      <h4>Chargement .... </h4>
    </div>
  ) : (
    <ProtectedRoute>
      <div
        className="container card"
        style={{ marginTop: "15px", paddingTop: 5 }}
      >
        <br />
        <p style={{ fontWeight: "bold", fontSize: 20 }}>
          <FontAwesomeIcon icon={faBriefcase} className="arrow-in-profile" />
          Modifier Experience
          <Link
            to={`${process.env.PUBLIC_URL}/consulter-voter-cv`}
            className="btn btn-primary"
            style={{ borderRadius: 0, float: "inline-end" }}
          >
            Précédent
          </Link>
        </p>
        <div style={{ borderTop: "3px solid #eee" }}>
          <br />
        </div>
        <Form style={{ background: "#f1f4fa", padding: "10px", margin: 1 }}>
          <FormExperience
            experiences={experiences}
            onChangeExperience={handleChangeExperience}
            onToggleEncoureExperiance={handleCheckboxChangeExperience}
            onChangeEntreprise={onChangeEntreprise}
            searchInputEntreprise={searchInputEntreprise}
            filteredResultsEntreprise={filteredResultsEntreprise}
            selectItemsEntreprise={selectItemsEntreprise}
          />
          <button
            type="submit"
            className="btn"
            onClick={handleModifiereExperience}
            style={{
              borderRadius: "5px",
              padding: "7px",
              float: "right",
              backgroundColor: "#00ab9f",
              marginTop: 5,
            }}
          >
            Modifier
          </button>
        </Form>
      </div>
    </ProtectedRoute>
  );
}
